import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 31\" id=\"minus\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" fill=\"#3483B2\" /><rect width=\"3\" height=\"17\" x=\"14\" y=\"7\" fill=\"#FFF\" rx=\"1.5\" transform=\"rotate(-90 15.5 15.5)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol